export const getFinalSort = (sort, data) => {
  const finalSort = sort;
  if(sort !== data) {
    for (let i = sort.length; i < data.length; i++) {
      finalSort.push(data[i].id);
    }
  }
  return finalSort;
}